import DataExtractionService from '../../dataExtraction/DataExtractionService';
import UrlService from '../../UrlService';

import { createCRMMessageHandler } from './crmMessageHandler';

export const salesloftMessageHandler = createCRMMessageHandler({
  isCompanyPage: UrlService.isSalesloftCompanyPage,
  isContactPage: UrlService.isSalesloftContactPage,
  extractionService: DataExtractionService.salesloft,
});
